export default function (state = null, action) {
  switch (action.type) {
    case 'FETCH_INVOICES_SUCCESS':
      return action.response ? action.response.map(convertStripeInvoice) : []

    case 'LOGOUT':
      return null

    default:
      return state
  }
}

function convertStripeInvoice(invoice) {
  const cardInfo = invoice.charge?.payment_method_details?.card || {}
  const paymentAmount = invoice.charge?.amount
  const periodStart = invoice.lines.data[0]?.period?.start
  const periodEnd = invoice.lines.data[0]?.period?.end
  return {
    cardInfo: {
      brand: cardInfo.brand,
      last4: cardInfo.last4,
    },
    paymentAmount,
    paid: invoice.paid,
    // convert unix timestamp (in seconds) to JS timestamp (in ms)
    date: invoice.created ? invoice.created * 1000 : null,
    periodStart: periodStart ? periodStart * 1000 : null,
    periodEnd: periodEnd ? periodEnd * 1000 : null,
    hostedUrl: invoice.hosted_invoice_url,
  }
}
